var map = {
	"../pages/BOOK-READER/book-details-modal/book-details-modal.module": [
		587,
		0
	],
	"../pages/paypal/paypal.module": [
		588,
		1
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 268;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 268
// module chunks = 2